// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/bundle." + {"4":"ab190ce03a8be08a71f9","397":"3503e639ea98daf84d1a"}[chunkId] + ".min.js";
};